// Resolving stored media paths to URLs that actually load.
//
// The .NET host's wwwroot is mirrored into blob storage and served publicly from
// media.swancreate.com/images/TheFigApp/wwwroot. Anything the database stores as a path
// relative to that wwwroot — district logos, certificates, uploaded files — resolves from
// blob by prefixing it, which is one less reason to keep api.figk-12.com alive.
//
// This started in the support module and is now used by the state dashboard too, so it
// lives here rather than being copied. There is exactly one rule for building these URLs
// and it should have exactly one implementation.

const FIGAPP_MEDIA_BASE = "https://media.swancreate.com/images/TheFigApp/wwwroot";

/** Resolve a wwwroot-relative path to its blob URL. Absolute URLs pass through. */
export const buildMediaUrl = (relativePath) => {
  const p = String(relativePath || "").trim();
  if (!p) return null;
  if (p.startsWith("http")) return p;
  return `${FIGAPP_MEDIA_BASE}${p.startsWith("/") ? p : `/${p}`}`;
};

/**
 * A district's logo, from the columns that actually hold one.
 *
 * NOT SchoolDistrict.DistrictLogoUrl: that column points at
 * media.swancreate.com/images/DistrictLogo/... with no TheFigApp/wwwroot segment, and
 * every value 404s. It is stale and should be ignored or backfilled. ThumbnailLogoURL
 * and DistrictLogo are wwwroot-relative and verified to resolve.
 */
export const districtLogoUrl = (district) =>
  buildMediaUrl(district?.ThumbnailLogoURL || district?.DistrictLogo);

/** First letter of a district name, for the fallback tile when no logo resolves. */
export const districtInitial = (name) =>
  String(name || "?").trim().charAt(0).toUpperCase() || "?";
